"use strict";
/**
 * ErrorPage
 * Designed to have props passed in via a component that has access to the location property. Examples:
 * Redirect component, Link component, Route component
 * The optional `handleOnClick` prop adds an extra layer of functionality to the Link component. Specifically, if a page
 * persists state in localStorage or sessionStorage, a function to clear sessionStorage or reset state can be passed
 * so that the user is not stuck on the error page (since the state that got them there would otherwise remain).
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var error_page_styles_1 = require("./error_page.styles");
var isValidExternalUrl = function (input) {
    try {
        return ['http:', 'https:'].includes(new URL(input).protocol);
    }
    catch (_) {
        return false;
    }
};
var ErrorPage = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var errorTitle = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : 'An Error Occurred';
    var errorMessage = (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.location) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "We're sorry, something went wrong when processing your request.";
    var routeDisplayText = (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.location) === null || _g === void 0 ? void 0 : _g.state) === null || _h === void 0 ? void 0 : _h.routeDisplayText) !== null && _j !== void 0 ? _j : 'Return to home page';
    var routePath = (_m = (_l = (_k = props === null || props === void 0 ? void 0 : props.location) === null || _k === void 0 ? void 0 : _k.state) === null || _l === void 0 ? void 0 : _l.routePath) !== null && _m !== void 0 ? _m : '/';
    var handleOnClick = (_p = (_o = props === null || props === void 0 ? void 0 : props.location) === null || _o === void 0 ? void 0 : _o.state) === null || _p === void 0 ? void 0 : _p.handleOnClick;
    return (react_1.default.createElement(error_page_styles_1.ContentContainer, null,
        react_1.default.createElement(storm_ui_1.Card, null,
            react_1.default.createElement(storm_ui_1.Text, { type: 'h2' }, errorTitle),
            react_1.default.createElement(error_page_styles_1.CardBody, null,
                react_1.default.createElement(storm_ui_1.Text, null, errorMessage)),
            react_1.default.createElement(error_page_styles_1.CardFooter, null, isValidExternalUrl(routePath) ? (react_1.default.createElement(error_page_styles_1.StyledStormLink, { href: routePath, onClick: handleOnClick }, routeDisplayText)) : (react_1.default.createElement(error_page_styles_1.StyledReactRouterLink, { to: routePath, onClick: handleOnClick }, routeDisplayText))))));
};
exports.ErrorPage = ErrorPage;
